import api from './api';

const API_SCOPE = 'api://6069b616-c7f2-4978-9f9c-180ec12f1844/access_as_user';

async function getSupportToken(msalInstance) {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) throw new Error('No authenticated account');
  try {
    const resp = await msalInstance.acquireTokenSilent({
      scopes: [API_SCOPE],
      account: accounts[0],
    });
    return resp.accessToken;
  } catch {
    const resp = await msalInstance.acquireTokenPopup({
      scopes: [API_SCOPE],
    });
    return resp.accessToken;
  }
}

export async function getIncidents(msalInstance) {
  const token = await getSupportToken(msalInstance);
  const { data } = await api.get('/api/support/incidents', {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

export async function getSuppliers(msalInstance) {
  const token = await getSupportToken(msalInstance);
  const { data } = await api.get('/api/support/suppliers', {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

export async function getSupplierFiles(supplierId, msalInstance) {
  const token = await getSupportToken(msalInstance);
  const { data } = await api.get(`/api/support/supplier-files/${supplierId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

export async function createIncident(formData, msalInstance) {
  const token = await getSupportToken(msalInstance);
  const { data } = await api.post('/api/support/incidents', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
}

export async function updateIncident(id, payload, msalInstance) {
  const token = await getSupportToken(msalInstance);
  const { data } = await api.patch(`/api/support/incidents/${id}`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}
